import React, { useRef, useState } from 'react'
import styled from 'styled-components'
import { MediumButton } from '../../styles/Buttons';
import { Form } from '../../styles/FormStyle';
import { useTranslation } from 'react-i18next';
import FormActionBtns from '../FormActionBtns';

const InputWrapper = styled.div`
    display: flex;
    justify-content: center; 
    align-items: center; 
    gap: 1rem; 

    & > div:first-of-type,
    & > div:last-of-type {
        flex: 1; 
    } 
`;

const ExpandTextArea = styled.div`
    position: relative; 
    display: inline-block; 
    width: 100%; 
    
    & > div {
        position: absolute;
        bottom: 28px; 
        right: 10px; 
        width: 16px;
        height: 16px; 
        cursor: se-resize;
        background-size: cover;
        background-image: url('/expand-icon.svg');  
        pointer-events: none; 
        transform: rotate(90deg); 
    }
`;

function GenericForm({ item, handleOnChange, handleSubmit, title, dynamicFields, buttonColorTheme, handleEditCancel, isEditing }) {
    const { t } = useTranslation(); 
    const [height, setHeight] = useState(100)
    const textareaRef = useRef(null);

    const handleMouseDown = (event) => {
        const startY = event.clientY;
        const startHeight = textareaRef.current.offsetHeight;

        const onMouseMove = (e) => {
            const newHeight = startHeight + (e.clientY - startY)

            if (newHeight > 50) {
                setHeight(newHeight)
            }
        }

        const onMouseUp = () => {
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', onMouseUp);
        }
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
    }

    // retrive the text and url from activity.text/activity.url in dynamicFields > subField
    const getNestedValue = (subFieldObj, fieldName) => {
        return fieldName.split('.').reduce((name, part) => name && name[part], subFieldObj);
    };

    return (
        <Form $theme={buttonColorTheme} onSubmit={handleSubmit}>
            <h5>{title}</h5>
            {dynamicFields.map((field, index) => (
                <div key={index}>
                    {!!field.subFields && (
                        <InputWrapper key={index}>
                            {field.subFields.map((subField, index) => (
                                <div key={index}>
                                    <label>
                                        {subField.label}
                                        {!!subField.required && (
                                            <span> *</span>
                                        )}
                                    </label>
                                    <input
                                        key={index}
                                        type={subField.type}
                                        name={subField.name}
                                        placeholder={subField.placeholder}
                                        value={getNestedValue(item, subField.name)}
                                        onChange={handleOnChange}
                                        required={subField.required === true}
                                    />
                                </div>
                            ))}
                        </InputWrapper>
                    )}
                    {field.type === 'textarea' ? (
                        <>
                            <label>
                                {field.label}
                                {!!field.required && (
                                    <span> *</span>
                                )}
                            </label>
                            <ExpandTextArea onMouseDown={handleMouseDown}>
                                <textarea
                                    key={index}
                                    name={field.name}
                                    placeholder={field.placeholder}
                                    value={item[field.name] || getNestedValue(item, field.name)}
                                    onChange={handleOnChange}
                                    required={field.required === true}
                                    ref={textareaRef}
                                    style={{ height: `${height}px`, resize: 'none', padding: '8px' }}
                                    spellCheck={false}
                                ></textarea>
                                <div></div>
                            </ExpandTextArea>
                        </>
                    ) : (
                        <>
                            <label>
                                {field.label}
                                {field.required === true && (
                                    <span> *</span>
                                )}
                            </label>
                            <input
                                key={index}
                                type={field.type}
                                name={field.name}
                                placeholder={field.placeholder}
                                value={item[field.name] || getNestedValue(item, field.name)}
                                onChange={handleOnChange}
                                required={field.required === true}
                            />
                        </>

                    )}
                </div>
            ))}
            {!!isEditing ? (
                <FormActionBtns 
                    theme={buttonColorTheme}
                    handleEditCancel={handleEditCancel}
                />
            ) : (
                <MediumButton
                    type='submit'
                    $theme={buttonColorTheme}
                >
                    {t('common.addBtnLabel')}
                </MediumButton>
            )}
        </Form>
    )
}

export default GenericForm